import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "reactstrap";
import "./Organization.css";
import organization_icon from "../../assets/images/insight-admin.svg";
import Search from "../../components/InputFields/Search";
import { useLocation } from 'react-router-dom';
import { sideTabs } from "./Constant";
import AssignUser from "./AssignUser";
import { getAssignedStaffs } from "../../api/User";
import { decryptData } from "../../utils/helper";
import { failed } from "../../utils/Tostify";
import Loader from "../../components/Loader/Loader";
import CustomPagination from "../../components/Pagination/CustomPagination";
import profile_img from "../../assets/images/man_profile.jpg";
import moment from "moment";

function Userslisting({ direction, ...args }) {
  let token = useSelector(state => state.userReducer.token);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [assignedUserList, setAssignedUserList] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" }); // Sorting state
  const location = useLocation();
  const fromEdit = location.state.fromEdit;
  const [search, setSearch] = useState("");
  const [showAssignModal, setShowAssignModal] = useState(false);
  const orgData = location?.state?.orgData;
  const ActiveStep = location?.state?.ActiveStep;

  const getAssignedUserList = async (page = 1, limit = 10, searchKey = "") => {
    let res = "";
    try {
      setIsLoading(true);
      setSearch(searchKey);
      res = await getAssignedStaffs({
        dispatch,
        token,
        page,
        limit,
        searchKey,
        orgId: orgData?.orgId || orgData?._id
      });
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        setAssignedUserList(responseData);
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const handlePagination = (page) => {
    getAssignedUserList(page, 10);
  };

  useEffect(() => {
    getAssignedUserList();
  }, []);

  const handleUserBtn = () => {
    navigate("/super-admin/organization");
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
        direction = "desc";
    }
    setSortConfig({ key, direction });
};

const sortData = (data) => {
    if (!sortConfig.key) return data;
    return [...data].sort((a, b) => {
        let aValue = a[sortConfig.key]?.toLowerCase();
        let bValue = b[sortConfig.key]?.toLowerCase();
        // Special case for sorting the Admin field, which is nested
        if (sortConfig.key === "role") {
            aValue = (a.defaultRole?.label || "").toLowerCase(); // If contact[0] or name is undefined, use an empty string
            bValue = (b.defaultRole?.label || "").toLowerCase();
        }
        if (aValue < bValue) {
            return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (aValue > bValue) {
            return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
    });
};

const filteredAndSortedData = sortData(assignedUserList?.items);

  return (
    <Fragment>
      {isLoading && <Loader />}
      {showAssignModal && (<AssignUser  refetchClinic={()=> {}} refetch={getAssignedUserList} setShowAssignModal={() => {setShowAssignModal(!showAssignModal);}} orgData={orgData} assignedUserList={assignedUserList?.items} from={"org"} />)}
      <div className="admin_application_container organization_blk organization_table clinic_listing_container">
        <div className="d-flex justify-content-between align-items-center main-header-block header-bg">
          <div className="left_header d-flex align-items-center">
            <img src={organization_icon} alt="organization_icon" />
            <h2 className="home-title">Organization</h2>
          </div>
          <div className="right_header_block d-flex justify-content-between align-items-center flex-wrap">
            <div className="right_header d-flex align-items-center">
              <Search
                value={search}
                onChange={(e) => { getAssignedUserList(null, null, e.target.value.toLowerCase()); }}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="d-flex gap-2 align-items-center">
                <img src={profile_img} alt="img_profile" className="img_profile_one" />
                <h3>{orgData?.orgName}</h3>
              </div>
          <button className="add_hospital" onClick={() => setShowAssignModal(true)}>Add User</button>
        </div>
        <div className="d-flex gap-3 clinic_list">
          <div className="sidebar_container">
            {sideTabs({ ActiveStep, fromEdit, navigate, orgData })}
          </div>
          <div className="sidetab_body">
            <div className="table_space p-0">
              <div className="table-responsive">
                <table >
                  <thead>
                    <tr className="header_table">
                      <th></th>
                      <th onClick={() => handleSort("firstName")}>Name<i className='fas fa-sort'></i></th>
                      <th onClick={() => handleSort("role")}>Role <i className='fas fa-sort'></i></th>
                      <th>Created</th>
                      <th>Status</th>
                      <th onClick={() => handleSort("city")}>Location<i className='fas fa-sort'></i></th>
                      <th onClick={() => handleSort("email")}>Email<i className='fas fa-sort'></i></th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  {filteredAndSortedData?.length > 0 ? filteredAndSortedData?.map((user) => (
                    <tbody key={user?._id}>
                      <tr>
                        <td colSpan={9} height={5} className="bg_light"></td>
                      </tr>
                      <tr className="first_block">
                        <td></td>
                        <td><h6>{user?.firstName + " " + user?.lastName}</h6></td>
                        <td>{user?.defaultRole?.label || "--"}</td>
                        <td>{moment(user?.createdAt).format("MMM-DD-YYYY")}</td>
                        <td><div className={user?.active === true ? "active_block_btn" : "not_active_btn"}>{user?.active ? "Active" : "Not Active"}</div></td>
                        <td>{user?.city + "," + user?.state}</td>
                        <td>{user?.email}</td>
                      </tr>
                    </tbody>)) : <tr><td colSpan={10}><p className="text-center">No Data Found</p></td></tr>}
                </table>
              </div>
              <CustomPagination tableData={assignedUserList?.items} totalPages={assignedUserList?.totalPages} totalRows={assignedUserList?.totalItems} rowsPerPage={10} page={assignedUserList?.items?.length > 0 ? assignedUserList?.currentPage : 0} handlePage={handlePagination} />
              <div className="d-flex justify-content-end mt-3 gap-3">
                  <button className="save_btn" type="submit" onClick={handleUserBtn}>Finish</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default Userslisting;
